// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrap-entry-sidebar-info-content {
  height: auto !important;
  padding: 0 16px 16px !important;
}

.scrap-entry-sidebar-info-body {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 13px;
  line-height: 1.55;
}

.rp-report-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.rp-reports-tabs-wrap {
  width: 100%;
}

.rp-reports-tabs {
  width: 100%;
}

.rp-tab-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.rp-tab-label__text {
  font-weight: 500;
}

.rp-tab-panel-inner {
  padding-top: 0.25rem;
}

.reports-filter-shell {
  width: 100%;
}

.top-filters {
  width: 100%;
}
@media (max-width: 768px) {
  .top-filters > .d-flex.justify-content-between {
    flex-direction: column;
    align-items: stretch !important;
    gap: 0.75rem;
    width: 100%;
  }
  .top-filters > .d-flex.justify-content-between .btn {
    width: 100%;
  }
}

.list-filters__panel {
  padding: 0;
  background: transparent;
  border-top: none;
  width: 100%;
}

.list-filters__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.25rem;
  align-items: flex-end;
  width: 100%;
}
@media (max-width: 768px) {
  .list-filters__grid {
    flex-direction: column;
    align-items: stretch;
  }
}

.list-filters__field {
  min-width: 0;
  flex: 1 1 200px;
  max-width: 100%;
  box-sizing: border-box;
}
@media (max-width: 768px) {
  .list-filters__field {
    flex: 1 1 100%;
    min-width: 100%;
  }
}

.list-filters__control {
  width: 100%;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #e2e5e8);
  border-radius: 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}
.list-filters__control .dropdown {
  width: 100%;
}
.list-filters__control .dropdown__trigger {
  width: 100%;
  box-sizing: border-box;
  border: none;
  box-shadow: none;
}
.list-filters__control .m-select {
  margin-bottom: 0;
}
.list-filters__control .m-select-selected {
  border: none !important;
  box-shadow: none !important;
}
.list-filters__control:hover {
  border-color: var(--m-border-card-file, #cfd8e3);
}
.list-filters__control:focus-within {
  border-color: rgba(13, 110, 253, 0.45);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.12);
}

.list-filters__control--select {
  padding: 0;
  overflow: visible;
}
.list-filters__control--select .select-container__label {
  display: none;
}
.list-filters__control--select .select-container__selected,
.list-filters__control--select .m-select-selected {
  border: none !important;
  box-shadow: none !important;
  border-radius: 8px;
}

.reports-filter-date {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0.5rem 0.65rem;
  font-size: 0.875rem;
  border: none;
  background: transparent;
  color: var(--m-text);
  box-sizing: border-box;
}
.reports-filter-date:focus {
  outline: none;
}

.rp-filter-machines {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--m-border, #e9ecef);
  width: 100%;
}

.list-filters__footer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--m-border, #e9ecef);
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
@media (max-width: 768px) {
  .list-filters__footer {
    justify-content: stretch;
  }
  .list-filters__footer .btn {
    width: 100%;
  }
}

.rp-filter-bar__chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.rp-year-filter-bar {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.rp-year-filter-bar__title {
  flex: 1 1 auto;
  min-width: 0;
}

.rp-year-filter-group {
  flex: 0 0 auto;
}

.rp-year-filter {
  width: 150px;
  flex: 0 0 auto;
}
.rp-year-filter--month {
  width: 170px;
}
.rp-year-filter .list-filters__control--select {
  min-height: 40px;
}
.rp-year-filter .list-filters__control--select .dropdown__trigger {
  min-height: 40px;
  padding: 0.375rem 0.625rem;
  font-size: 0.9375rem;
}

.rp-revenue-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
  align-items: stretch;
}
@media (max-width: 991px) {
  .rp-revenue-grid-2 {
    grid-template-columns: 1fr;
  }
}

.rp-kpi-card {
  min-height: 88px;
  border: 1px solid var(--m-border, #e2e8f0);
  border-top: 2px solid var(--m-primary);
  border-radius: var(--m-border-radius-md, 8px);
  transition: box-shadow 0.15s ease;
}
.rp-kpi-card:hover {
  box-shadow: var(--m-header-box-shadow, 0 1px 3px rgba(0, 0, 0, 0.06));
}

.rp-kpi-card__label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--m-text-light, #64748b);
}

.rp-kpi-card__ref-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
}

.rp-kpi-card__value {
  font-weight: 700;
  font-size: 1.35rem;
  color: var(--m-text);
  line-height: 1.25;
}

.rp-kpi-card__sub {
  line-height: 1.35;
}

.rp-ref-rejected {
  color: #e74c3c;
  font-weight: 600;
}

.rp-ref-rework {
  color: #f39c12;
  font-weight: 600;
}

.rp-section-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  padding: 2rem 1rem;
}
.rp-section-state--loading {
  flex-direction: column;
  gap: 12px;
  color: var(--m-primary);
}
.rp-section-state--empty {
  border: 1px dashed var(--m-border, #e2e8f0);
  border-radius: var(--m-border-radius-md, 8px);
  background: var(--m-background-subtle-primary, #f8fafc);
  margin-top: 0.25rem;
}

.rp-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 768px) {
  .rp-grid-2 {
    grid-template-columns: 1fr;
  }
}

.rp-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}
@media (max-width: 992px) {
  .rp-grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 480px) {
  .rp-grid-4 {
    grid-template-columns: 1fr;
  }
}

.rp-grid-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}
@media (max-width: 992px) {
  .rp-grid-5 {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 576px) {
  .rp-grid-5 {
    grid-template-columns: repeat(2, 1fr);
  }
}

.rp-grid-6 {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
}
@media (max-width: 1200px) {
  .rp-grid-6 {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 640px) {
  .rp-grid-6 {
    grid-template-columns: repeat(2, 1fr);
  }
}

.rp-chip {
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid var(--m-border, #dde2ee);
  background: var(--m-card-background-color, #fff);
  color: var(--m-text, #475569);
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
  outline: none;
}
.rp-chip:hover {
  border-color: var(--m-primary);
  color: var(--m-primary);
}
.rp-chip.active {
  background: var(--m-primary);
  border-color: var(--m-primary);
  color: var(--m-white, #fff);
}

.rp-spin {
  animation: rp-spin 0.9s linear infinite;
}

@keyframes rp-spin {
  to {
    transform: rotate(360deg);
  }
}
.rp-matrix-wrap {
  overflow-x: auto;
}

.rp-matrix {
  border-collapse: collapse;
  font-size: 13px;
  min-width: 500px;
}
.rp-matrix th,
.rp-matrix td {
  padding: 10px 16px;
  border: 1px solid var(--m-border, #e2e8f0);
  text-align: center;
  font-weight: 600;
  min-width: 88px;
}
.rp-matrix .rp-matrix-corner {
  background: var(--m-background-subtle-primary, #f8fafc);
  color: var(--m-text-light, #7a8499);
  font-size: 11px;
  text-align: left;
  font-weight: 700;
  white-space: nowrap;
}
.rp-matrix .rp-matrix-row-label {
  font-weight: 700;
  text-align: left;
  background: var(--m-background-subtle-primary, #f8fafc);
  white-space: nowrap;
}
.rp-matrix .rp-matrix-cell {
  font-weight: 700;
  font-size: 14px;
  transition: background 0.15s;
}

.rp-matrix-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 1rem;
}

.rp-matrix-toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.rp-matrix-stats {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.rp-matrix-breakdown-wrap {
  overflow-x: auto;
}

.rp-matrix-breakdown {
  border-collapse: collapse;
  font-size: 13px;
  min-width: 860px;
  width: 100%;
}
.rp-matrix-breakdown th,
.rp-matrix-breakdown td {
  padding: 10px 14px;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: middle;
}
.rp-matrix-breakdown thead th {
  background: #f8fafc;
  font-weight: 700;
  color: #334155;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}
.rp-matrix-breakdown .rp-matrix-muted {
  color: #94a3b8;
  font-size: 11px;
}
.rp-matrix-breakdown .rp-matrix-group-row {
  background: #fff;
}
.rp-matrix-breakdown .rp-matrix-group-row.is-clickable {
  cursor: pointer;
}
.rp-matrix-breakdown .rp-matrix-group-row.is-clickable:hover {
  background: #f8fafc;
}
.rp-matrix-breakdown .rp-matrix-group-row.is-open {
  background: #f0f9ff;
  border-bottom-color: #dbeafe;
}
.rp-matrix-breakdown .rp-matrix-group-label {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rp-matrix-breakdown .rp-matrix-chevron {
  display: inline-flex;
  color: #64748b;
  flex-shrink: 0;
}
.rp-matrix-breakdown .rp-matrix-scope {
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
}
.rp-matrix-breakdown .rp-matrix-child-row {
  background: #fafbfc;
}
.rp-matrix-breakdown .rp-matrix-child-row td {
  border-bottom: 1px solid #f1f5f9;
  font-size: 12px;
}
.rp-matrix-breakdown .rp-matrix-child-variant {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 8px;
}
.rp-matrix-breakdown .rp-matrix-child-indent {
  display: inline-block;
  width: 12px;
  border-left: 2px solid #cbd5e1;
  align-self: stretch;
  min-height: 18px;
  flex-shrink: 0;
}
.rp-matrix-breakdown .rp-matrix-variant-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.rp-matrix-breakdown .rp-matrix-total-row td {
  background: #f0f9ff;
  border-top: 2px solid #3b82f6;
  border-bottom: none;
  font-weight: 700;
  color: #1e3a5f;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
}
.rp-matrix-breakdown .rp-matrix-total-row .rp-matrix-total-label {
  font-size: 11px;
  letter-spacing: 0.06em;
  color: #2563eb;
}

.rp-dist-total-row td {
  background: #f0fdfa;
  border-top: 2px solid #0d9488;
  border-bottom: none;
  font-weight: 700;
  color: #134e4a;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
}
.rp-dist-total-row td:first-child {
  padding-left: 1.5rem;
}
.rp-dist-total-row td:last-child {
  padding-right: 1.5rem;
}
.rp-dist-total-row .rp-dist-total-label {
  font-size: 11px;
  letter-spacing: 0.06em;
  color: #0f766e;
}
.rp-dist-total-row .rp-dist-total-pct {
  font-weight: 600;
  color: #0f766e;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/Reports/Reports.scss"],"names":[],"mappings":"AACA;EACE,uBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAAF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,WAAA;AAFF;AAIE;EACE;IACE,sBAAA;IACA,+BAAA;IACA,YAAA;IACA,WAAA;EAFJ;EAII;IACE,WAAA;EAFN;AACF;;AAOA;EACE,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;AAJF;AAME;EAPF;IAQI,sBAAA;IACA,oBAAA;EAHF;AACF;;AAMA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAHF;AAKE;EANF;IAOI,cAAA;IACA,eAAA;EAFF;AACF;;AAKA;EACE,WAAA;EACA,gDAAA;EACA,0CAAA;EACA,kBAAA;EACA,wDACE;EAEF,sBAAA;AAJF;AAME;EACE,WAAA;AAJJ;AAOE;EACE,WAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AALJ;AAQE;EACE,gBAAA;AANJ;AASE;EACE,uBAAA;EACA,2BAAA;AAPJ;AAUE;EACE,gDAAA;AARJ;AAWE;EACE,sCAAA;EACA,8CAAA;AATJ;;AAaA;EACE,UAAA;EACA,iBAAA;AAVF;AAYE;EACE,aAAA;AAVJ;AAaE;;EAEE,uBAAA;EACA,2BAAA;EACA,kBAAA;AAXJ;;AAeA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;AAZF;AAcE;EACE,aAAA;AAZJ;;AAgBA;EACE,gBAAA;EACA,iBAAA;EACA,8CAAA;EACA,WAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,iBAAA;EACA,8CAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;AAbF;AAeE;EARF;IASI,wBAAA;EAZF;EAcE;IACE,WAAA;EAZJ;AACF;;AAgBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAbF;;AAiBA;EACE,+BAAA;EACA,kCAAA;AAdF;AAgBE;EACE,cAAA;EACA,YAAA;AAdJ;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,YAAA;EACA,cAAA;AAfF;AAiBE;EACE,YAAA;AAfJ;AAkBE;EACE,gBAAA;AAhBJ;AAkBI;EACE,gBAAA;EACA,0BAAA;EACA,oBAAA;AAhBN;;AAqBA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;AAlBF;AAoBE;EAPF;IAQI,0BAAA;EAjBF;AACF;;AAqBA;EACE,gBAAA;EACA,0CAAA;EACA,sCAAA;EACA,6CAAA;EACA,iCAAA;AAlBF;AAoBE;EACE,qEAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mCAAA;AAnBF;;AAsBA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,+CAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,iBAAA;AAnBF;;AAuBA;EACE,cAAA;EACA,gBAAA;AApBF;;AAuBA;EACE,cAAA;EACA,gBAAA;AApBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AArBF;AAuBE;EACE,sBAAA;EACA,SAAA;EACA,uBAAA;AArBJ;AAwBE;EACE,2CAAA;EACA,6CAAA;EACA,uDAAA;EACA,mBAAA;AAtBJ;;AA2BA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAxBF;AAyBE;EAJF;IAKI,0BAAA;EAtBF;AACF;;AAyBA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAtBF;AAuBE;EAJF;IAKI,qCAAA;EApBF;AACF;AAqBE;EAPF;IAQI,0BAAA;EAlBF;AACF;;AAqBA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAlBF;AAmBE;EAJF;IAKI,qCAAA;EAhBF;AACF;AAiBE;EAPF;IAQI,qCAAA;EAdF;AACF;;AAiBA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAdF;AAeE;EAJF;IAKI,qCAAA;EAZF;AACF;AAaE;EAPF;IAQI,qCAAA;EAVF;AACF;;AAcA;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,gDAAA;EACA,6BAAA;EACA,eAAA;EACA,6DAAA;EACA,aAAA;AAXF;AAaE;EACE,8BAAA;EACA,uBAAA;AAXJ;AAcE;EACE,4BAAA;EACA,8BAAA;EACA,2BAAA;AAZJ;;AAiBA;EACE,uCAAA;AAdF;;AAiBA;EACE;IACE,yBAAA;EAdF;AACF;AAkBA;EACE,gBAAA;AAhBF;;AAmBA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAhBF;AAkBE;;EAEE,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAhBJ;AAmBE;EACE,uDAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAjBJ;AAoBE;EACE,gBAAA;EACA,gBAAA;EACA,uDAAA;EACA,mBAAA;AAlBJ;AAqBE;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;AAnBJ;;AAwBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AArBF;;AAwBA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,gBAAA;AArBF;;AAwBA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AArBF;AAuBE;;EAEE,kBAAA;EACA,gCAAA;EACA,sBAAA;AArBJ;AAwBE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;AAtBJ;AAyBE;EACE,cAAA;EACA,eAAA;AAvBJ;AA0BE;EACE,gBAAA;AAxBJ;AA0BI;EACE,eAAA;AAxBN;AA0BM;EACE,mBAAA;AAxBR;AA4BI;EACE,mBAAA;EACA,4BAAA;AA1BN;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA5BJ;AA+BE;EACE,oBAAA;EACA,cAAA;EACA,cAAA;AA7BJ;AAgCE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,mBAAA;AA/BJ;AAiCI;EACE,gCAAA;EACA,eAAA;AA/BN;AAmCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AAjCJ;AAoCE;EACE,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAlCJ;AAqCE;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAnCJ;AAuCI;EACE,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AArCN;AAwCI;EACE,eAAA;EACA,sBAAA;EACA,cAAA;AAtCN;;AA6CE;EACE,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AA1CJ;AA4CI;EACE,oBAAA;AA1CN;AA6CI;EACE,qBAAA;AA3CN;AA+CE;EACE,eAAA;EACA,sBAAA;EACA,cAAA;AA7CJ;AAgDE;EACE,gBAAA;EACA,cAAA;AA9CJ","sourcesContent":["// ─── Scrap entry sidebar ─────────────────────────────────────────────────────\n.scrap-entry-sidebar-info-content {\n  height: auto !important;\n  padding: 0 16px 16px !important;\n}\n\n.scrap-entry-sidebar-info-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n// ─── Page layout ─────────────────────────────────────────────────────────────\n.rp-report-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.rp-reports-tabs-wrap {\n  width: 100%;\n}\n\n.rp-reports-tabs {\n  width: 100%;\n}\n\n.rp-tab-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rp-tab-label__text {\n  font-weight: 500;\n}\n\n.rp-tab-panel-inner {\n  padding-top: 0.25rem;\n}\n\n// ─── Filter card (Deliveries list pattern: top-filters + list-filters) ───────\n.reports-filter-shell {\n  width: 100%;\n}\n\n.top-filters {\n  width: 100%;\n\n  @media (max-width: 768px) {\n    > .d-flex.justify-content-between {\n      flex-direction: column;\n      align-items: stretch !important;\n      gap: 0.75rem;\n      width: 100%;\n\n      .btn {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.list-filters__panel {\n  padding: 0;\n  background: transparent;\n  border-top: none;\n  width: 100%;\n}\n\n.list-filters__grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem 1.25rem;\n  align-items: flex-end;\n  width: 100%;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.list-filters__field {\n  min-width: 0;\n  flex: 1 1 200px;\n  max-width: 100%;\n  box-sizing: border-box;\n\n  @media (max-width: 768px) {\n    flex: 1 1 100%;\n    min-width: 100%;\n  }\n}\n\n.list-filters__control {\n  width: 100%;\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #e2e5e8);\n  border-radius: 8px;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n  box-sizing: border-box;\n\n  .dropdown {\n    width: 100%;\n  }\n\n  .dropdown__trigger {\n    width: 100%;\n    box-sizing: border-box;\n    border: none;\n    box-shadow: none;\n  }\n\n  .m-select {\n    margin-bottom: 0;\n  }\n\n  .m-select-selected {\n    border: none !important;\n    box-shadow: none !important;\n  }\n\n  &:hover {\n    border-color: var(--m-border-card-file, #cfd8e3);\n  }\n\n  &:focus-within {\n    border-color: rgba(13, 110, 253, 0.45);\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.12);\n  }\n}\n\n.list-filters__control--select {\n  padding: 0;\n  overflow: visible;\n\n  .select-container__label {\n    display: none;\n  }\n\n  .select-container__selected,\n  .m-select-selected {\n    border: none !important;\n    box-shadow: none !important;\n    border-radius: 8px;\n  }\n}\n\n.reports-filter-date {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0.5rem 0.65rem;\n  font-size: 0.875rem;\n  border: none;\n  background: transparent;\n  color: var(--m-text);\n  box-sizing: border-box;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.rp-filter-machines {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--m-border, #e9ecef);\n  width: 100%;\n}\n\n.list-filters__footer {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--m-border, #e9ecef);\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n\n  @media (max-width: 768px) {\n    justify-content: stretch;\n\n    .btn {\n      width: 100%;\n    }\n  }\n}\n\n.rp-filter-bar__chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n// ─── Compact year filter (sales/deliveries reports) ───────────────────────────\n.rp-year-filter-bar {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n\n  &__title {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n}\n\n.rp-year-filter-group {\n  flex: 0 0 auto;\n}\n\n.rp-year-filter {\n  width: 150px;\n  flex: 0 0 auto;\n\n  &--month {\n    width: 170px;\n  }\n\n  .list-filters__control--select {\n    min-height: 40px;\n\n    .dropdown__trigger {\n      min-height: 40px;\n      padding: 0.375rem 0.625rem;\n      font-size: 0.9375rem;\n    }\n  }\n}\n\n.rp-revenue-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n  margin-bottom: 1rem;\n  align-items: stretch;\n\n  @media (max-width: 991px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n// ─── KPI Cards (one neutral card style; optional legend dot only) ────────────\n.rp-kpi-card {\n  min-height: 88px;\n  border: 1px solid var(--m-border, #e2e8f0);\n  border-top: 2px solid var(--m-primary);\n  border-radius: var(--m-border-radius-md, 8px);\n  transition: box-shadow 0.15s ease;\n\n  &:hover {\n    box-shadow: var(--m-header-box-shadow, 0 1px 3px rgba(0, 0, 0, 0.06));\n  }\n}\n\n.rp-kpi-card__label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--m-text-light, #64748b);\n}\n\n.rp-kpi-card__ref-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);\n}\n\n.rp-kpi-card__value {\n  font-weight: 700;\n  font-size: 1.35rem;\n  color: var(--m-text);\n  line-height: 1.25;\n}\n\n.rp-kpi-card__sub {\n  line-height: 1.35;\n}\n\n// Reference emphasis — same hues as RP_SERIES / charts\n.rp-ref-rejected {\n  color: #e74c3c;\n  font-weight: 600;\n}\n\n.rp-ref-rework {\n  color: #f39c12;\n  font-weight: 600;\n}\n\n// ─── Loading / empty states ────────────────────────────────────────────────────\n.rp-section-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 180px;\n  padding: 2rem 1rem;\n\n  &--loading {\n    flex-direction: column;\n    gap: 12px;\n    color: var(--m-primary);\n  }\n\n  &--empty {\n    border: 1px dashed var(--m-border, #e2e8f0);\n    border-radius: var(--m-border-radius-md, 8px);\n    background: var(--m-background-subtle-primary, #f8fafc);\n    margin-top: 0.25rem;\n  }\n}\n\n// ─── Grid helpers ────────────────────────────────────────────────────────────\n.rp-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.rp-grid-4 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  @media (max-width: 992px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 480px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.rp-grid-5 {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 12px;\n  @media (max-width: 992px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 576px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.rp-grid-6 {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 12px;\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 640px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n// ─── Machine / period chip ───────────────────────────────────────────────────\n.rp-chip {\n  padding: 5px 14px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid var(--m-border, #dde2ee);\n  background: var(--m-card-background-color, #fff);\n  color: var(--m-text, #475569);\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s, color 0.15s;\n  outline: none;\n\n  &:hover {\n    border-color: var(--m-primary);\n    color: var(--m-primary);\n  }\n\n  &.active {\n    background: var(--m-primary);\n    border-color: var(--m-primary);\n    color: var(--m-white, #fff);\n  }\n}\n\n// ─── Spinner animation ───────────────────────────────────────────────────────\n.rp-spin {\n  animation: rp-spin 0.9s linear infinite;\n}\n\n@keyframes rp-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n// ─── Transition matrix ───────────────────────────────────────────────────────\n.rp-matrix-wrap {\n  overflow-x: auto;\n}\n\n.rp-matrix {\n  border-collapse: collapse;\n  font-size: 13px;\n  min-width: 500px;\n\n  th,\n  td {\n    padding: 10px 16px;\n    border: 1px solid var(--m-border, #e2e8f0);\n    text-align: center;\n    font-weight: 600;\n    min-width: 88px;\n  }\n\n  .rp-matrix-corner {\n    background: var(--m-background-subtle-primary, #f8fafc);\n    color: var(--m-text-light, #7a8499);\n    font-size: 11px;\n    text-align: left;\n    font-weight: 700;\n    white-space: nowrap;\n  }\n\n  .rp-matrix-row-label {\n    font-weight: 700;\n    text-align: left;\n    background: var(--m-background-subtle-primary, #f8fafc);\n    white-space: nowrap;\n  }\n\n  .rp-matrix-cell {\n    font-weight: 700;\n    font-size: 14px;\n    transition: background 0.15s;\n  }\n}\n\n// Machine × part matrix — grouped by main part\n.rp-matrix-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 1rem;\n}\n\n.rp-matrix-toolbar-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.rp-matrix-stats {\n  font-size: 12px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.rp-matrix-breakdown-wrap {\n  overflow-x: auto;\n}\n\n.rp-matrix-breakdown {\n  border-collapse: collapse;\n  font-size: 13px;\n  min-width: 860px;\n  width: 100%;\n\n  th,\n  td {\n    padding: 10px 14px;\n    border-bottom: 1px solid #e2e8f0;\n    vertical-align: middle;\n  }\n\n  thead th {\n    background: #f8fafc;\n    font-weight: 700;\n    color: #334155;\n    border-bottom: 2px solid #e2e8f0;\n    white-space: nowrap;\n  }\n\n  .rp-matrix-muted {\n    color: #94a3b8;\n    font-size: 11px;\n  }\n\n  .rp-matrix-group-row {\n    background: #fff;\n\n    &.is-clickable {\n      cursor: pointer;\n\n      &:hover {\n        background: #f8fafc;\n      }\n    }\n\n    &.is-open {\n      background: #f0f9ff;\n      border-bottom-color: #dbeafe;\n    }\n  }\n\n  .rp-matrix-group-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .rp-matrix-chevron {\n    display: inline-flex;\n    color: #64748b;\n    flex-shrink: 0;\n  }\n\n  .rp-matrix-scope {\n    font-size: 12px;\n    color: #64748b;\n    font-weight: 600;\n  }\n\n  .rp-matrix-child-row {\n    background: #fafbfc;\n\n    td {\n      border-bottom: 1px solid #f1f5f9;\n      font-size: 12px;\n    }\n  }\n\n  .rp-matrix-child-variant {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding-left: 8px;\n  }\n\n  .rp-matrix-child-indent {\n    display: inline-block;\n    width: 12px;\n    border-left: 2px solid #cbd5e1;\n    align-self: stretch;\n    min-height: 18px;\n    flex-shrink: 0;\n  }\n\n  .rp-matrix-variant-badge {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 4px;\n    background: #e0f2fe;\n    color: #0369a1;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n  }\n\n  .rp-matrix-total-row {\n    td {\n      background: #f0f9ff;\n      border-top: 2px solid #3b82f6;\n      border-bottom: none;\n      font-weight: 700;\n      color: #1e3a5f;\n      padding-top: 0.9rem;\n      padding-bottom: 0.9rem;\n    }\n\n    .rp-matrix-total-label {\n      font-size: 11px;\n      letter-spacing: 0.06em;\n      color: #2563eb;\n    }\n  }\n}\n\n// Production distribution — period total row (tfoot)\n.rp-dist-total-row {\n  td {\n    background: #f0fdfa;\n    border-top: 2px solid #0d9488;\n    border-bottom: none;\n    font-weight: 700;\n    color: #134e4a;\n    padding-top: 0.9rem;\n    padding-bottom: 0.9rem;\n\n    &:first-child {\n      padding-left: 1.5rem;\n    }\n\n    &:last-child {\n      padding-right: 1.5rem;\n    }\n  }\n\n  .rp-dist-total-label {\n    font-size: 11px;\n    letter-spacing: 0.06em;\n    color: #0f766e;\n  }\n\n  .rp-dist-total-pct {\n    font-weight: 600;\n    color: #0f766e;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
